var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d2-drawer-container",
      attrs: { flex: "dir:top main:justify box:last" }
    },
    [
      _c(
        "div",
        { staticClass: "d2-drawer-container--body" },
        [
          _c("d2-scrollbar", { staticStyle: { height: "100%" } }, [
            _c(
              "div",
              { staticClass: "d2-drawer-container--body-wrap" },
              [_vm._t("default")],
              2
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d2-drawer-container--footer" },
        [_vm._t("footer")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }